import { Turbo } from "@hotwired/turbo-rails";
import "packs/engines/signup/controllers";
import "utils/supercast";

import { logEvent, setUserProperties, identify, startSessionRecording } from "utils/analytics";

import "utils/frame_missing_handler";

if (document.cookie.indexOf('sc_debug') !== -1) {
  startSessionRecording();
}

window.Turbo = Turbo;

window.analytics = { logEvent, setUserProperties, identify };
